import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import './ServicePage.css';

const ShopifyDevelopment = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
    window.scrollTo(0, 0);
  }, []);

  const features = [
    'Custom Shopify store setup',
    'Theme development & customization',
    'Shopify app development',
    'Product catalog management',
    'Payment gateway integration',
    'Shipping & fulfillment setup',
    'SEO optimization',
    'Performance optimization',
    'Mobile-responsive design',
    'Third-party app integration'
  ];

  return (
    <div className="service-page">
      <Navbar />
      <div className="service-hero">
        <Link to="/" className="back-button" data-aos="fade-right">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="service-hero-content" data-aos="fade-up">
          <h1 className="service-page-title">Shopify Development</h1>
          <p className="service-hero-tagline">Build powerful, scalable Shopify stores that drive sales and growth.</p>
        </div>
      </div>

      <div className="service-content">
        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Overview</h2>
          <p className="section-text">
            We specialize in custom Shopify store development, theme customization, and app integration. 
            Our Shopify solutions are optimized for performance, conversions, and scalability to help your e-commerce business thrive.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">What You Get</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-item" data-aos="fade-up" data-aos-delay={index * 50}>
                <FaCheck className="check-icon" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="service-cta" data-aos="fade-up">
          <Link to="/contact" className="cta-button-primary">
            Get Started →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ShopifyDevelopment;

